import React from 'react';
import { Link } from 'react-router-dom';
import { FaProjectDiagram } from 'react-icons/fa';
import './ConnectCtaSection.css';

import renoTradiesImage from "../../../assets/images/img_trade_reno.jpg";

const ConnectCtaSection = ({ 
    image,
    titleLine1, 
    titleBold, 
    titleThin, 
    titleEnd,
    subtitle 
}) => {
    
    const displayImage = image || renoTradiesImage;
    const tLine1 = titleLine1 || "CONNECT WITH";
    const tBold = titleBold || "MORE";
    const tThin = titleThin || "LOCAL";
    const tEnd = titleEnd || "CLIENTS"; // Now defaults to thin in CSS
    const sub = subtitle || "List your business at Building Start and get leads for jobs Posted by local clients.";

    return (
        <section className="ccs-section">
            <div className="bs-container">
                <div className="ccs-card">
                    
                    {/* Left Side: Image */}
                    <div className="ccs-image-wrapper">
                        <img src={displayImage} alt="Tradespeople connecting" className="ccs-image" />
                    </div>

                    {/* Right Side: Content */}
                    <div className="ccs-content-wrapper">
                        
                        {/* Header Row: Icon + Line 1 */}
                        <div className="ccs-header-row">
                            <div className="ccs-icon-circle">
                                <FaProjectDiagram />
                            </div>
                            <span className="ccs-title-line1">{tLine1}</span>
                        </div>

                        {/* Second Row: MORE LOCAL CLIENTS */}
                        <h2 className="ccs-main-headline">
                            <span className="ccs-font-heavy">{tBold} </span>
                            <span className="ccs-font-thin">{tThin} </span>
                            <span className="ccs-font-thin">{tEnd}</span>
                        </h2>

                        <p className="ccs-subtitle">
                            {sub}
                        </p>

                        <div className="ccs-btn-row">
                            <Link to="/select-role" className="ccs-btn-primary">
                                List your Business Today
                            </Link>
                            <Link to="/business-landing" className="ccs-btn-secondary">
                                Learn More
                            </Link>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
};

export default ConnectCtaSection;